import { UnsuccessfulReasonService, Dots, addParamsToUrl, UNSUCCESSFUL_REASONS, UnsuccessfulReasonOptions,
         toastr, SUCCESS_REPONSE_CODE, CommonAction, CustomToastrAction} from '@/imports-files/pages/clients/recruitments/unsuccessful-reasons';

export class UnsuccessfulReasonAction
{

  constructor(args, router)
  {
    var keys                        =  Object.keys(args);
    this.unsuccessfulReasonService  =  new UnsuccessfulReasonService();
    this.router                     =  router;
    this.customToastrAction         =   new CustomToastrAction(); 

    // Creating class variables
    for(let i = 0; i < keys.length; i++) 
    {
        if(typeof this[`${keys[i]}`] == 'undefined')
        {
            this[`${keys[i]}`] =  args[keys[i]] ;
            // console.log(this[`${keys[i]}`]);
        }
       
    }
    // Creating class variables
  }

  async getUnsuccessfullReasonsData(router)
  {
      let param_list      =    new CommonAction().getQueryInObject();
      let result          =    await this.unsuccessfulReasonService.getReasonsListData(param_list);
      this.setApiError( result.request );
      result.data.reasons.forEach((element, index) =>
      {
          element['key'] = index+1;
      })
      return result;
  }
  
  getUnsuccessfullReasonseColumns(router, unsuccessfulReasonAction, readAccess)
  {  
      return ([
                  {
                      name: 'Unsuccessful Reasons',
                      selector: row => row.reason_text,
                      sortable: true, 
                      sortField: 'reason'
                  },
                  {
                      name: 'Last Edited By',
                      selector: row => row.edited_by_name || '-',
                      sortable: true, 
                      sortField: 'edited_by_name'
                  },
                  {
                      name: !readAccess ? 'Action' : '',
                      selector: row => {
                                          return(
                                                 <>{!readAccess && <div  className         =   "DotsOptions"
                                                           onClick           =   {(event) => {   this.openJobOptions(event); }}> 
                                                          {row.can_edit ? <>
                                                                                <Dots className   =   "Dots Close"/>
                                                                                <UnsuccessfulReasonOptions  options                   =   {UNSUCCESSFUL_REASONS.unsuccessfulReasonsOptions} 
                                                                                                            unsuccessfulReasonAction  =   {unsuccessfulReasonAction}
                                                                                                            id                        =   {row.id}
                                                                                                            reason_id                 =   {row.reason_id}
                                                                                />
                                                                          </> : '-'}
                                                    </div>}</>)
                                        }
                  }
                  
                
          ])
  
  }

  
  openJobOptions(event)
  {
      event.stopPropagation();
      var dots_element = event.currentTarget.querySelector('.Dots');
      var element = event.currentTarget.querySelector('.JobActionOptions')

      if(dots_element.classList.contains('Close'))
      {
          this.closeAllJobsOptions();
          element.classList.remove('Close');
          element.classList.add('Open');

          dots_element.classList.remove('Close');
          dots_element.classList.add('Open');
      }
      else
      {
          this.closeAllJobsOptions();
          element.classList.remove('Open');
          element.classList.add('Close');

          dots_element.classList.remove('Open');
          dots_element.classList.add('Close');
      }
  }

  closeAllJobsOptions()
  {
      var element = document.querySelector('.JobActionOptions.Open');
      var dots_element = document.querySelector('.Dots.Open');
      if(element)
      {
          element.classList.remove('Open');
          element.classList.add('Close');
          dots_element.classList.remove('Open');
          dots_element.classList.add('Close');
      }
  }

  async changeSearchFilterData( event)
  {
      this.router.query.page    =   this.router.query.page || 1
      var param_list            =   this.router.query;
      param_list.search_text    =   event.target.value ;
      param_list.search_text    ==   '' ?  delete param_list.search_text : param_list.search_text ;
      addParamsToUrl(param_list, this.router);
      var result                =   await this.unsuccessfulReasonService.getReasonsListData(param_list);
      this.setApiError( result.request );
      this.setUnsuccessfulReasonData( result.data );
  }

  async handlePerRowsSorting( router, column, sortDirection, setUnsuccessfulReasonData)
  {
      var param_list            =    router.query;
      param_list.col_name       =    column.sortField;
      param_list.order          =    sortDirection;
      addParamsToUrl(param_list, router);
      var result  =  await this.unsuccessfulReasonService.getReasonsListData(param_list);
      this.setApiError( result.request );
      setUnsuccessfulReasonData(result.data);
      
  }

  async handlePerRowsChange( router, per_page, setUnsuccessfulReasonData )
  {
      var param_list            =    router.query;
      param_list.per_page       =    per_page;
      addParamsToUrl(param_list, router);
      var result                =    await this.unsuccessfulReasonService.getReasonsListData(param_list);
      this.setApiError( result.request );
      setUnsuccessfulReasonData(result.data);  
      
  }

  async handlePageChange( router, page_number, setUnsuccessfulReasonData)
  {
      var param_list            =    router.query;
      param_list.page           =    page_number;
      addParamsToUrl(param_list, router);
      var result  =  await this.unsuccessfulReasonService.getReasonsListData(param_list);
      this.setApiError( result.request );
      setUnsuccessfulReasonData(result.data);
  }

  performJobAction(ActionName, params)
  {
      switch(ActionName)
      {
          case 'edit':
                          this.editEmailTemplate(params);
                          break;
          case 'delete':
                          this.deleteEmailTemplate(params);
                          break;
          default: '';
      }  
  }
    
  async editEmailTemplate(args)
  {
      UNSUCCESSFUL_REASONS.unsuccessfulReasonsForm.texts.heading  =  UNSUCCESSFUL_REASONS.unsuccessfulReasonsForm.texts.edit_heading;
      let result                                                  =  await this.unsuccessfulReasonService.showReasonListData(args.id);
      this.setApiError(result.request );
      this.selectedReasonId = args.id;
      this.setFormInitialValues({id: args.reason_id, reason:result.data.reason.reason_text});
      this.setFormValidations(UNSUCCESSFUL_REASONS.unsuccessfulReasonsForm.formValidation);
      this.setSubmitFormAction( () => values => this.submitEditUnsuccessfulForm(values) )
      this.setShowUnsuccessfulReason(true);
  }

  deleteEmailTemplate(args)
  {
      this.setSelectedReasonId(args.id)
      this.setDeleteConfirmation(true);
  }

  async deleteTemplate(selectedReasonId)
  {
      var result = await this.unsuccessfulReasonService.deleteReasonsListData(selectedReasonId);
      this.setApiError( result.request );
      this.customToastrAction.setNormalToastr(result?.data?.success, 'success');
    //   toastr.success(result?.data?.success);
      this.setDeleteConfirmation(false);
      this.setUnsuccessfulReasonData(result?.data)
  }

  async submitCreateUnsuccessfulForm(values)
  {
      this.setDisabledSubmitButton(true);  
      let body    =  { client_user_unsuccessful_reason: { reason_attributes : values}};
      body        =  Object.assign(this.router.query, body);
      body.page   =  new CommonAction().getPageFromUrl();
      
      let result = await this.unsuccessfulReasonService.createReasonsListData(body);
      this.setApiError(result.request);
      if(result.request.status == SUCCESS_REPONSE_CODE)
      {
        this.customToastrAction.setNormalToastr(result.data.success, 'success');
        // toastr.success( result.data.success );
      }
      this.setUnsuccessfulReasonData(result.data);
      this.setShowUnsuccessfulReason(false);
      this.setDisabledSubmitButton(false);
  }

  async submitEditUnsuccessfulForm(values)
  {
    
      let body    =  {client_user_unsuccessful_reason: { reason_attributes : values} };
      body        =  Object.assign(this.router.query, body);
      body.page   =  new CommonAction().getPageFromUrl();

      let result  =  await this.unsuccessfulReasonService.updateReasonsListData(body, this.selectedReasonId);
      this.setApiError(result.request);
      if(result.request.status == SUCCESS_REPONSE_CODE)
      {
        this.customToastrAction.setNormalToastr(result.data.success, 'success');
        // toastr.success( result.data.success );
      }
      
      this.setUnsuccessfulReasonData(result.data);
      this.setShowUnsuccessfulReason(false);
  }

  
    closeAllJobsOptions()
    {
        var element = document.querySelector('.JobActionOptions.Open');
        var dots_element = document.querySelector('.Dots.Open');
        if(element)
        {
            element.classList.remove('Open');
            element.classList.add('Close');
            dots_element.classList.remove('Open');
            dots_element.classList.add('Close');
        }
    }


    changeDelay(event, timer, setTimer) 
    {
      if (timer) 
      {
        clearTimeout(timer);
        setTimer(null);
      }
      setTimer(
        setTimeout(() => {
                                this.changeSearchFilterData( event );
                         }, 500)
      );
    }
}
